import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';

class Header extends Component {
  render() {
    const {t, i18n} = this.props;
    return (
      <div className={'header big vertical-center'}>

        <div className={'center'}>
          <div className={'max-width width flex-header'}>
            <div className={'left'}>
              <div className={''}>
                <div className={'top'}>{t('header.top')}</div>
                <h1 className={'big'}>{t('header.title')}</h1>
                <div className={'bottom'}>{t('header.text')}
                </div>
                <br/><br/>
                {/*<Button type='button' text={t('header.start-now')} submit*/}
                {/*        action={() => window.location.hrefprocess.env.REACT_APP_API_MEMBER_URL + '/' + i18n.language + '/login'}/>*/}
                {/*<Button type='button2' text={t('header.our-products')} paddingLeft/>*/}

                <a target={'_new'}
                   href={"//" + process.env.REACT_APP_MEMBER_DOMAIN + "/" + i18n.language + "/login"}
                   className={'button'}
                >{t('header.start-now')}</a>

              </div>
            </div>
            <div className={'image-container'}>
              {this.props.mobile ?
                <div className={'image-dc'}/> :
                <div className={'image-dc-new'}/>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(translate('home')(Header));
